module.exports = __webpack_public_path__ + "a807694c2dd0dc89f0bfaab947698ad2.png";